import {
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';

import { FdkIconComponent } from '../icon/icon.component';

export type FdkAlertVariant = 'success' | 'error' | 'warning';

@Component({
  selector: 'fdk-alert',
  imports: [FdkIconComponent],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class FdkAlertComponent {
  @Input({ required: true }) title!: string;
  @Input({ required: true }) description!: string;
  @Input() variant: FdkAlertVariant = 'success';
}
